import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d3eca95e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "purchases-list" }
const _hoisted_2 = { class: "scroll-component-container" }
const _hoisted_3 = { class: "table-responsive mb-16" }
const _hoisted_4 = { class: "fit text-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "fit text-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon icon-blank-alt-light fw-bold" })
], -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  colspan: "222222",
  class: "empty-state py-8 px-12 text-center"
}
const _hoisted_8 = { class: "h-100 w-100 d-flex flex-column align-items-center justify-content-center text-center" }
const _hoisted_9 = { class: "h5 title text-primary mb-48" }
const _hoisted_10 = { class: "fit text-center" }
const _hoisted_11 = { class: "fit text-center" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-view-light",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_13 = { class: "fw-normal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_table_header = _resolveComponent("v-table-header")!
  const _component_v_button = _resolveComponent("v-button")!
  const _component_v_table_body = _resolveComponent("v-table-body")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_the_patient_purchase_authorization_show = _resolveComponent("the-patient-purchase-authorization-show")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_v_table, { class: "table-bordered" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_table_header, null, {
                default: _withCtx(() => [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t('Fecha')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('Productos')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('Estado')), 1),
                    _hoisted_5
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_table_body, null, {
                default: _withCtx(() => [
                  (!_ctx.purchaseAuthorizations || !_ctx.purchaseAuthorizations.length)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                        _createElementVNode("td", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('No hay autorizaciones de compra')), 1)
                          ])
                        ])
                      ]))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.purchaseAuthorizations, (purchaseAuthorization) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: purchaseAuthorization.id
                        }, [
                          _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.$str.formatDate(purchaseAuthorization.dueDate)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.$t('{count} productos distintos', { count: purchaseAuthorization.products.length })), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.status(purchaseAuthorization)), 1),
                          _createElementVNode("td", _hoisted_11, [
                            _createVNode(_component_v_button, {
                              variant: "icon",
                              "aria-label": _ctx.$t('Visualizar'),
                              class: "d-flex flex-column p-0 m-auto",
                              onClick: ($event: any) => (_ctx.showPurchaseAuthorizationShowModal(purchaseAuthorization))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_12,
                                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('Ver')), 1)
                              ]),
                              _: 2
                            }, 1032, ["aria-label", "onClick"])
                          ])
                        ]))
                      }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    (_ctx.modalToShow === 'the-patient-purchase-authorization-show')
      ? (_openBlock(), _createBlock(_component_the_patient_purchase_authorization_show, {
          key: 0,
          onClosed: _cache[0] || (_cache[0] = ($event: any) => {_ctx.modalToShow = null; _ctx.setCurrentPurchase()})
        }))
      : _createCommentVNode("", true)
  ], 64))
}